//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import { mdiClose } from '@mdi/js'

export default {
  setup() {
    const isDialogVisible = ref(false)
    const notifications = ref(false)
    const sound = ref(true)
    const widgets = ref(false)

    return {
      isDialogVisible,
      notifications,
      sound,
      widgets,

      // icon
      icons: {
        mdiClose,
      },
    }
  },
}
